<template>
  <div class="pc-table">
    <div class="pc-table-userCount">
      <el-table :data="tableA" :border="true" style="width: 100%">
        <el-table-column prop="name" label="总览" width="160">
        </el-table-column>
        <el-table-column prop="number" label="数量" width="160">
        </el-table-column>
      </el-table>
    </div>

    <div class="pc-table-userVitality">
      <el-table :data="tableB" :border="true" style="width: 100%">
        <el-table-column prop="name" label="活跃数" width="160">
        </el-table-column>
        <el-table-column prop="number" label="数量" width="160">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>



<script>
export default {
  props: ["userStatisticses"],
  data() {
    return {
      tableA: [
        { name: "用户总数", number: null },
        { name: "活跃用户数(匿名)", number: null },
      ],
      tableB: [
        { name: "日活数", number: null },
        { name: "周活数", number: null },
        { name: "月活数", number: null },
      ],
    };
  },
  watch: {
    userStatisticses() {
      this.tableA[0].number = this.userStatisticses.user_count;
      this.tableA[1].number = this.userStatisticses.anonymous_active_count;
      this.tableB[0].number = this.userStatisticses.today_active_count;
      this.tableB[1].number = this.userStatisticses.week_active_count;
      this.tableB[2].number = this.userStatisticses.month_active_count;
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-table {
  position: relative;
  width: 320px;
  height: 380px;

  .pc-table-userCount {
    border-radius: 8px;
    box-shadow: $shadowCard;
    /deep/ .cell {
      text-align: center;
      font-family: $chinese;
      font-weight: bold;
      font-size: 14px;
      color: $mainTitle;
      letter-spacing: 0.5px;
      padding-left: 7px;
      padding-right: 7px;
    }
    /deep/ .is-leaf {
      font-weight: normal;
      background: $lightGreya;
    }
    /deep/ .el-table__row:nth-of-type(3) td:nth-of-type(1) .cell {
      font-size: 12px;
      white-space: nowrap;
      overflow: visible;
    }
    /deep/ .el-table--scrollable-x .el-table__body-wrapper {
      overflow: hidden;
    }
  }
  /deep/ .el-table__row {
      td:nth-of-type(2) {
        .cell {
          color: $lightenYellow !important;
        }
      }
    }


  /deep/ td {
    height: 56px;
  }

  .pc-table-userVitality {
    position: absolute;
    left: 0;
    bottom: -20px;
    border-radius: 8px;
    box-shadow: $shadowCard;
    /deep/ .cell {
      text-align: center;
      font-family: $chinese;
      font-size: 14px;
      color: $mainTitle;
      letter-spacing: 0.5px;
      font-weight: bold;
    }
    /deep/ .is-leaf {
      font-weight: normal;
      background: $lightGreya;
    }
  }

  /deep/ th,
  /deep/ td {
    padding: 10px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userList/TableUserCount.vue